import request from "@/api/config.js";

export function RequestCreate(data) {
  return request({
    url: `request/new`,
    method: "post",
    data,
  });
}

export function RequestUpdate(data) {
  return request({
    url: `request/update`,
    method: "post",
    data,
  });
}

export function RequestStatuses() {
  return request({
    url: `request/statuses-list`,
    method: "get",
  });
}

export function RequestList(education_id) {
  return request({
    url: `request/request-list/${education_id}`,
    method: "get",
  });
}

export function GetNoCourse(limit, offset) {
  return request({
    url: `request/get-no-course/${limit}/${offset}`,
    method: "get",
  });
}